document.addEventListener("DOMContentLoaded", () => {
    const dropdownList = document.querySelectorAll(".select-wrapper");

    dropdownList?.forEach((dropdown) => {
        const selectEl = dropdown.querySelector(".select");
        const optionList = dropdown.querySelectorAll(".custom-option");

        optionList.forEach((option) => {
            option.addEventListener("click", () => {
                if (option.classList.contains("selected")) return false;
                option.parentNode.querySelector(".custom-option.selected")?.classList.remove("selected");
                option.classList.add("selected");
                option.closest(".select").querySelector(".select__trigger span").innerHTML = option.innerHTML;
            });
        });

        dropdown.addEventListener("click", () => {
            selectEl.classList.toggle("open");
        });

        // close dropdown list when clicking out of dropdown
        window.addEventListener("click", (e) => {
            !selectEl.contains(e.target) && selectEl.classList.remove("open");
        });
    });
});
